export const LicenseBorrowRouting = [
  {
    path: "/license-manage/license-borrow/list",
    name: "license-borrow-list",
    meta: { title: "借用申请" },
    component: () => import("@/views/license-manage/license-borrow/list/index.vue"),
  },
  {
    hidden: true,
    path: "/license-manage/license-borrow/create",
    name: "license-borrow-create",
    meta: { title: "新建借用申请" },
    component: () => import("@/views/license-manage/license-borrow/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/license-manage/license-borrow/edit/:id",
    name: "license-borrow-edit",
    meta: { title: "编辑借用申请" },
    component: () => import("@/views/license-manage/license-borrow/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/license-manage/license-borrow/detail/:id",
    name: "license-borrow-detail",
    meta: { title: "借用申请详情" },
    component: () => import("@/views/license-manage/license-borrow/form-detail/index.vue"),
  },
  {
    hidden: true,
    path: "/license-manage/license-borrow/flowPrint/:id",
    name: "license-borrow-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "license-borrow-flow-print" */ "@/views/license-manage/license-borrow/flow-print/index.vue"
      ),
  },
];
